import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { notifyPdfLoadedSection } from '../../../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../../../PDFRenderer/PDFRendererTypes';
import { useFpId } from '../../hooks/useFpId';
import { useRouteParams } from '../hooks/useRouteParams';
import { MonteCarloDTO } from '../types/monteCarlo.types';
import { queryKeys } from './queryKeys';

const fetchMonteCarlo = async (clientId: string, fpId: string | null): Promise<MonteCarloDTO> => {
  return authFetch(
    urlWithParams('/Consumer/MC', {
      clientId,
      fpId,
    }),
  );
};

interface UseMonteCarloQueryParams {
  enabled?: boolean;
}

export const useMonteCarloQuery = ({ enabled = true }: UseMonteCarloQueryParams = {}) => {
  const dispatch = useDispatch();

  const { clientId } = useRouteParams();

  const fpId = useFpId();

  return useQuery(
    queryKeys.monteCarlo(clientId, fpId),

    () => fetchMonteCarlo(clientId, fpId),

    {
      enabled,
      onSuccess() {
        dispatch(notifyPdfLoadedSection(PdfSectionType.RetirementMonteCarlo));
      },
    },
  );
};
